import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watchEffect } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-switch',
  props: {
    label: {},
    value: { type: Boolean },
    position: {}
  },
  emits: ["change", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const internalValue = ref(false);

function toggle() {
  internalValue.value = !internalValue.value;
  emit("change", internalValue.value);
  emit("update:modelValue", internalValue.value);
}

watchEffect(() => {
  internalValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["base-switch", [__props.position ?? 'left']])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["switch", {
        active: internalValue.value,
      }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "box" }, null, -1)
    ]))], 2),
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "label",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggle()))
        }, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})